export async function index() {
  const data = await this.$adminRepositories.revenue_reports.index();
  return data;
}
